import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import { useLocale } from 'hooks';

import { DesktopPage, Loader, TabMenu } from 'ui';

import { DesktopAssetsDetailsProps } from './DesktopAssetsDetails.types';
import { useStyles } from './DesktopAssetsDetails.styles';
import { OwnerDetails } from './ownerDetails/OwnerDetails';
import { AssetDetails } from './assetDetails/AssetDetails';
import { ManufacturerDetails } from './manufacturerDetails/ManufacturerDetails';
import { InstallerDetails } from './installerDetails/InstallerDetails';
import { VerifierDetails } from './verifierDetails/VerifierDetails';

export const DesktopAssetsDetails = ({ asset }: DesktopAssetsDetailsProps) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();

  const renderContent = () => {
    if (!asset) return <Loader suppressText fullScreen />;
    return (
      <Container disableGutters>
        <div className={classes.textContainer}>
          <Typography className={classes.mainTitle}>{formatMessage({ id: 'navigation.batteries' })}</Typography>
          <Typography className={classes.subtitle}>{formatMessage({ id: 'navigation.home' })}</Typography>
          <Typography className={classes.subtitle}>|</Typography>
          <Typography className={classes.subtitle}>{formatMessage({ id: 'navigation.batteries' })}</Typography>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TabMenu
              isFullScreen={false}
              activeColor="secondary"
              dense
              tabs={[
                {
                  label: formatMessage({ id: 'batteries_desktop.list' }),
                  content: <AssetDetails {...asset} />,
                },
              ]}
            />
          </Grid>
          <Grid item xs={8}>
            <TabMenu
              isFullScreen={false}
              activeColor="secondary"
              dense
              tabs={[
                {
                  label: formatMessage({ id: 'asset_details.owner' }),
                  content: <OwnerDetails {...asset} />,
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TabMenu
              isFullScreen={false}
              activeColor="secondary"
              dense
              tabs={[
                {
                  label: formatMessage({ id: 'asset_details.manufacturer' }),
                  content: <ManufacturerDetails {...asset} />,
                },
              ]}
            />
          </Grid>
          <Grid item xs={4}>
            <TabMenu
              isFullScreen={false}
              activeColor="secondary"
              dense
              tabs={[
                {
                  label: formatMessage({ id: 'asset_details.installer' }),
                  content: <InstallerDetails {...asset} />,
                },
              ]}
            />
          </Grid>
          <Grid item xs={4}>
            <TabMenu
              isFullScreen={false}
              activeColor="secondary"
              dense
              tabs={[
                {
                  label: formatMessage({ id: 'asset_details.verifier' }),
                  content: <VerifierDetails {...asset} />,
                },
              ]}
            />
          </Grid>
        </Grid>
      </Container>
    );
  };
  return (
    <>
      <DesktopPage>{renderContent()}</DesktopPage>
    </>
  );
};
